import { render, staticRenderFns } from "./CategoryStatus.vue?vue&type=template&id=0c0d82fa"
import script from "./CategoryStatus.vue?vue&type=script&lang=js"
export * from "./CategoryStatus.vue?vue&type=script&lang=js"
import style0 from "./CategoryStatus.vue?vue&type=style&index=0&id=0c0d82fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports